import { render, staticRenderFns } from "./system_management_home.vue?vue&type=template&id=70a75e5e&scoped=true&"
import script from "./system_management_home.vue?vue&type=script&lang=js&"
export * from "./system_management_home.vue?vue&type=script&lang=js&"
import style0 from "./system_management_home.vue?vue&type=style&index=0&id=70a75e5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a75e5e",
  null
  
)

export default component.exports